import type { ButtonProps } from '@mui/material/Button';

import { useCallback } from 'react';

import Button from '@mui/material/Button';

import { paths } from 'src/routes/paths';

import { CONFIG } from 'src/global-config';

import { useAuthContext } from 'src/auth/hooks';
import { getErrorMessage } from 'src/auth/utils';
import { signOut } from 'src/auth/context/amplify/action';

// ----------------------------------------------------------------------

type Props = ButtonProps & {
  onClose?: () => void;
};

export function SignOutButton({ onClose, sx, ...other }: Props) {
  const { checkUserSession } = useAuthContext();

  const handleLogout = useCallback(async () => {
    try {
      onClose?.();

      await signOut();

      await checkUserSession?.();

      const signInPath =
        CONFIG.auth.method === 'amplify' ? paths.auth.amplify.signIn : paths.auth.amplify.signIn;

      window.location.href = signInPath;
    } catch (error) {
      getErrorMessage(error);

      onClose?.();

      const signInPath =
        CONFIG.auth.method === 'amplify' ? paths.auth.amplify.signIn : paths.auth.amplify.signIn;
      window.location.href = signInPath;
    }
  }, [checkUserSession, onClose]);

  return (
    <Button
      fullWidth
      variant="soft"
      size="large"
      color="error"
      onClick={handleLogout}
      sx={sx}
      {...other}
    >
      Logout
    </Button>
  );
}
